/* global Blob */
import React from 'react';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Button } from 'react-toolbox/lib/button';

import { productionQueue } from '~/actions/boxStats';
import Spinner from '~/components/Spinner';

import style from './widget.scss';

export default class ProductionQueue extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: true,
      expanded: !props.indata.expandable
    };
  }

  componentDidMount() {
    productionQueue(
      this.context.apiClient,
      this.props.indata.locationIds,
      this.props.indata.skipInventory,
      [this.props.indata.orderStatus]
    )
      .then(r =>
        this.setState({
          products: r.data,
          loading: false
        })
      )
      .catch(() => this.setState({ loading: false }));
  }

  getProducts() {
    return this.state.products.filter(
      d => d.type === this.props.indata.orderStatus
    );
  }

  export(data) {
    const workbook = {
      SheetNames: ['Data'],
      Sheets: { Data: XLSX.utils.json_to_sheet(data) }
    };
    const wopts = { bookType: 'xlsx', bookSST: false, type: 'array' };
    const wbout = XLSX.write(workbook, wopts);
    saveAs(
      new Blob([wbout], { type: 'application/octet-stream' }),
      'export.xlsx'
    );
  }

  render() {
    const products = this.getProducts();
    return (
      <div className={this.props.className}>
        {this.state.loading && <Spinner />}
        {!this.state.loading && (
          <div
            className={[
              style.productionSection,
              this.state.expanded ? style.expanded : style.expandable
            ].join(' ')}
          >
            <div className={style.header}>
              <h5 className={style.productionTitle}>
                {this.props.indata.title || <span>&nbsp;</span>}
              </h5>
              <Button
                onClick={() => this.export(products)}
                label="Export .xlsx"
                icon="file_download"
                accent
                raised
                className={style.productionExport}
              />
              <Button
                onClick={() => this.setState({ expanded: true })}
                label="Show all"
                icon="keyboard_arrow_down"
                accent
                raised
                className={style.expand}
              />
            </div>
            <div className={style.products}>
              {products
                .sort((a, b) => {
                  return b.count - a.count;
                })
                .map(p => (
                  <div
                    key={`${p.sku}__${p.title}`}
                    className={style.productionRow}
                  >
                    <div
                      className={style.title}
                      dangerouslySetInnerHTML={{ __html: p.title }}
                    />
                    <div className={style.count}>{p.count}</div>
                  </div>
                ))}
            </div>
            {!this.state.loading &&
              products.length === 0 && (
                <div>No pending {this.props.indata.orderStatus} products</div>
              )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueue/widget.js